import { createSelector } from 'reselect'

const desmosSelector = state => state.desmos

const desmosCategorySelector = createSelector(
	[ desmosSelector ],
	desmosState => ({
		category: desmosState.categories[desmosState.category].categoryName,
	})
)

export default desmosCategorySelector
